<script lang="ts">
	// import { onMount } from 'svelte';
	import { goto } from '$app/navigation';
	import { browser } from '$app/environment';
	export let slug;
	export let title;

	const id = title
		.toLowerCase()
		.replace(/[^a-zA-Z ]/g, '')
		.replace(/\s/g, '-');

	const href: string = slug ? `/view/${slug}` : '#' + id;

	const handleNavAction = (event: MouseEvent | KeyboardEvent, navUrl: string) => {
		event.preventDefault();
		if (browser) goto(navUrl);
	};

	// onMount(() => {
	// 	console.log('Article: onMount', slug);
	// });
</script>

{#if slug}
	<div
		role="button"
		aria-pressed="false"
		tabindex="0"
		class="cursor-pointer border-none"
		on:click={(event) => handleNavAction(event, href)}
		on:keyup={(event) => {
			if (event.key === 'Enter') handleNavAction(event, href);
		}}
	>
		<article class="mb-0">
			<slot />
		</article>
	</div>
	<a href={slug ? href : null} class="hidden" aria-hidden="true">
		<!-- Hidden anchor tag for SEO and fallback navigation -->
		<slot />
	</a>
	<!-- <a data-sveltekit-preload-data="click" {href} alt={title}>
		<article class="mb-0">
			<slot />
		</article>
	</a> -->
{:else}
	<article class="mb-0">
		<slot />
	</article>
{/if}
